import { Link } from 'react-router-dom';
import { featuredComics } from '@/mocks/comics';

export default function HotSeriesSection() {
  return (
    <section className="bg-background-950 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-12">
          <div>
            <span className="inline-block px-4 py-1.5 border border-background-50/20 rounded-full text-background-50/70 text-xs font-medium">
              本周热门
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-background-50 mt-4">
              热门连载
            </h2>
            <p className="text-foreground-400 text-sm mt-2">
              大家正在追的韩漫，不容错过
            </p>
          </div>
          <Link
            to="/category"
            className="hidden md:inline-flex items-center gap-1.5 text-primary-300 hover:text-primary-200 text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer"
          >
            查看全部
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {featuredComics.map((comic) => (
            <article key={comic.id} className="group cursor-pointer">
              <Link to={`/comic/${comic.id}`} className="block">
                <div className="relative aspect-[3/4] rounded-2xl overflow-hidden mb-4">
                  <img
                    src={comic.coverImage}
                    alt={comic.title}
                    title={`${comic.title} - 尾巴漫画网好看的韩国漫画`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="inline-block px-2.5 py-1 bg-primary-500/90 backdrop-blur-sm text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                      {comic.rating}
                    </span>
                  </div>
                  {comic.status === '已完结' && (
                    <div className="absolute top-3 right-3">
                      <span className="inline-block px-2.5 py-1 bg-background-950/70 backdrop-blur-sm text-background-50 text-xs rounded-full whitespace-nowrap">
                        已完结
                      </span>
                    </div>
                  )}
                  <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className="absolute bottom-3 left-3 right-3">
                    <span className="text-background-50/80 text-xs">{comic.updateTime}</span>
                  </div>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-background-50 group-hover:text-primary-300 transition-colors duration-200 truncate">
                  {comic.title}
                </h3>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className="text-foreground-400 text-xs">{comic.author}</span>
                  <span className="text-foreground-600 text-xs">·</span>
                  <span className="text-foreground-400 text-xs">{comic.category}</span>
                </div>
              </Link>
            </article>
          ))}
        </div>

        <div className="mt-10 text-center md:hidden">
          <Link
            to="/category"
            className="inline-flex items-center gap-1.5 text-primary-300 hover:text-primary-200 text-sm font-medium whitespace-nowrap transition-colors duration-200 cursor-pointer"
          >
            查看全部漫画
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}